<!-- クーポンコード一般の入力フォーム -->
<template>
  <form class="wellcho-form" @submit.prevent="submitHandler">
    <div class="wellcho-form--wrapper">
      <div class="wellcho-form--input">
        <label for="code">クーポンコード</label>
        <input
          v-model="code"
          placeholder="クーポンコード"
          type="text"
          name="code"
        />
      </div>
      <div class="wellcho-form--message">
        <span v-if="showRequiredMessage"
          >クーポンコードが入力されていません</span
        >
        <span v-if="validated">クーポンコードが一致しません。</span>
      </div>
    </div>
    <button>
      AI診断を開始する→
    </button>
  </form>
</template>

<script>
export default {
  props: {
    validated: Boolean,
    showRequiredMessage: Boolean,
  },
  data() {
    return {
      code: "",
    };
  },
  methods: {
    submitHandler() {
      this.$emit("reset");
      //TODO コードのトリム処理などが必要
      if (this.code !== "" && this.code !== null && this.code !== undefined) {
        this.$emit("submit", this.code);
      } else {
        //this.showRequiredMessage = true;
        this.$emit("required", true);
      }
    },
  },
};
</script>

<style scoped>
.wellcho-form {
  box-sizing: border-box;
  padding: 40px;
  border: 4px solid #e6e6e6;
  border-radius: 5px;
  /**TODO widthの調整 */
  width: 500px;
}
.wellcho-form > input {
  display: inline-block;
  /**TODO widthの調整 */
  width: 500px;
  border-color: #e6e6e6;
}
.wellcho-form > button {
  margin-top: 20px;
  border: 2px solid #d8d8d8;
  background-color: #ffffff;
  height: inherit !important;
  display: block;
  padding: 10px !important;
  margin: 0 !important;
  font-family: "futura", "Century";
  background-color: #000;
  color: #fff;
  width: 100%;
}
.wellcho-form > button:hover {
  cursor: pointer;
  opacity: 0.7;
}

.wellcho-form--input > label {
  margin-right: 5px;
  display: none;
}
.wellcho-form--input > input {
  height: auto;
  padding: 10px;
}

.wellcho-form--message {
  margin-top: 10px;
  padding: 10px;
}
.wellcho-form--message > span {
  color: red;
  font-weight: bold;
}
</style>
